import { Facebook, Linkedin, Mail, MessageSquare, Link2, QrCode } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

export function qrUrl(data, size = 180) {
  return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&bgcolor=0A0A0A&color=D4AF37&data=${encodeURIComponent(data)}`;
}

export default function ShareBar({ url, title = "Support Golden Wolf Foundation", compact }) {
  const [showQr, setShowQr] = useState(false);
  const link = url || (typeof window !== "undefined" ? window.location.href : "");
  const enc = encodeURIComponent(link);
  const encT = encodeURIComponent(title);
  const btns = [
    { icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${enc}`, label: "Facebook" },
    { icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc}`, label: "LinkedIn" },
    { icon: MessageSquare, href: `sms:?&body=${encT}%20${enc}`, label: "Text" },
    { icon: Mail, href: `mailto:?subject=${encT}&body=${enc}`, label: "Email" },
  ];
  const copy = () => { navigator.clipboard.writeText(link); toast.success("Link copied to clipboard"); };
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="share-bar">
      {!compact && <span className="text-xs text-[#8A877B] mr-1">Share</span>}
      {btns.map((b) => (
        <a key={b.label} href={b.href} target="_blank" rel="noreferrer" aria-label={`Share on ${b.label}`}
          data-testid={`share-${b.label.toLowerCase()}`}
          className="w-9 h-9 flex items-center justify-center border border-white/15 text-[#C8C4B7] hover:text-[#D4AF37] hover:border-[#D4AF37]/50 transition-colors">
          <b.icon className="w-4 h-4" />
        </a>
      ))}
      <button onClick={copy} aria-label="Copy link" data-testid="share-copy"
        className="w-9 h-9 flex items-center justify-center border border-white/15 text-[#C8C4B7] hover:text-[#D4AF37] hover:border-[#D4AF37]/50 transition-colors">
        <Link2 className="w-4 h-4" />
      </button>
      <button onClick={() => setShowQr(!showQr)} aria-label="Show QR code" data-testid="share-qr"
        className="w-9 h-9 flex items-center justify-center border border-white/15 text-[#C8C4B7] hover:text-[#D4AF37] hover:border-[#D4AF37]/50 transition-colors">
        <QrCode className="w-4 h-4" />
      </button>
      {showQr && (
        <img src={qrUrl(link)} alt="QR code to share" className="w-24 h-24 border border-white/15 p-1 bg-[#0A0A0A]" />
      )}
    </div>
  );
}
